module.exports = __webpack_public_path__ + "static/trashy-paws-icon-beada8386a1eb2aacb93168036511512.png";